<template>

    <v-list-item v-if="!item.children" :to="routeToItem(item)" :title="item.title" exact>
      <v-list-item-icon>
        <v-icon color="secondary">{{item.icon}}</v-icon>
      </v-list-item-icon>

      <v-list-item-title class="secondary--text">{{item.title}}</v-list-item-title>
    </v-list-item>

    <v-list-group
      v-else
      :value="false"
      :prepend-icon="item.icon"
    >
      <template v-slot:prependIcon>
        <v-icon color="secondary">{{item.icon}}</v-icon>
      </template>
      <template v-slot:activator>
        <v-list-item-title class="secondary--text" :title="item.title">{{item.title}}</v-list-item-title>
      </template>
      <template v-slot:appendIcon>
        <v-icon color="secondary">mdi-chevron-down</v-icon>
      </template>

      <template v-for="item in item.children">
        <MenuSubNode 
          :item="item"
          :key="item.icon"
        ></MenuSubNode>
      </template>

    </v-list-group>

</template>

<script>
import MenuSubNode from "./MenuSubNode"

export default {

  name: 'Admin_Structure_MenuNode',

  components: {
    MenuSubNode
  },

  props: {
    item: Object
  },

  methods: {
    routeToItem(item) {
      if (item.name) {
        return { name: item.name };
      }
      return { path: item.path };
    },
  }

};
</script>